export const ru = {
    'display-href-description':
        'Отображаемая ссылка — это адрес страницы сайта, который будет показан в объявлении. Мы рекомендуем использовать ссылку, которая легко читается и позволяет пользователям понять, на какую страницу они перейдут после клика по объявлению.',
    'normal-view-title': 'Добавьте отображаемые ссылки в объявления',
    'normal-view-title-hint': 'Показывается, потому что у вас есть объявления без отображаемых ссылок',
    'popup-view-title': 'Добавьте отображаемую ссылку в объявление',
    'popup-view-title-hint': 'Показывается, потому что у объявления нет отображаемой ссылки',
    'show-many-banner-button': 'Посмотреть {count} объявлений',
    'show-one-banner-button': 'Посмотреть {count} объявление',
    'show-some-banner-button': 'Посмотреть {count} объявления'
};
